const styles = {
  root: {
    display: 'flex',
    justifyContent: 'center',
    overflow: 'hidden'
  },
  gridList: {
    width: 800,
    height: 750
  },
  button: {
    backgroundColor: '#FFF',
    marginRight: 20
  },
  headerText: {
    textAlign: 'center',
    marginTop: '10%',
    marginBottom: '10%'
  },
  headerText2: {
    textAlign: 'center',
    marginTop: '5%',
    marginBottom: '10%'
  },
  hrContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center'
  },
  text: {
    textAlign: 'center',
    marginTop: 300

  }
}

export default styles
